import path from 'ramda/src/path'
import { creatorDataKey } from 'root/src/shared/constants/keys'

export default path(['app', 'userData', creatorDataKey, 'broadcasterType'])
